import React, { Component } from "react";
import backimage from "../../../asset/business.png";
import Rates from "../../Section/Homepage/rate";
import SortProvider from "../../Section/Homepage/sort";
import Panel from "../Homepage/Panel";

class BusinessPage extends Component {
  render() {
    return (
      <Panel
        backimage={backimage}
        title="Afrex"
        detail="Find the best currency exchange 
            rate for your business."
      >
        <SortProvider />
        <Rates />
        <Rates />
      </Panel>
    );
  }
}

export default BusinessPage;
